import { FieldDictionary } from '@shopify/react-form';

import { TimeClockEntry } from '@web/timesheets/CreateTimesheetModal/createTimesheetModal.types';

export const useTimeClockSections = (timeClockFields: FieldDictionary<TimeClockEntry>[]) => {
  const isLastSection = (index: number) => index === timeClockFields.length - 1;
  const hasMultipleSections = timeClockFields.length >= 2;

  const remove = (index: number) => {
    const deletedField = timeClockFields[index].deleted;
    deletedField.onChange(true);
  };

  const visibleTimeClockFields = timeClockFields.filter(({ deleted }) => !deleted.value);

  return {
    isLastSection,
    hasMultipleSections,
    remove,
    visibleTimeClockFields,
  };
};
